$(document).ready(function(){
        var isSafari = false;
        var showRequest = false;
        var lastPushOfferShowExpired = false;


        var lastPushOffer=getCookie('lastPushOffer');
        var now=new Date();
        var nowStr=now.getDate()+'-'+now.getMonth()+'-'+now.getFullYear();
        var nowTs=new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();

        var lastPushOfferTs=0;
        if(lastPushOffer){
            var lastPushOfferParts=lastPushOffer.split('-');
            var lastPushOfferTs=new Date(lastPushOfferParts[2],lastPushOfferParts[1],lastPushOfferParts[0]).getTime();
        }

        if( (nowTs-lastPushOfferTs) >= (86400*1000*7)){
            lastPushOfferShowExpired = true;
        }

        function offerPushSubscribe(yesClickCallback){

				setTimeout(function(){
					var content=$('<div>');
					var str='<b>Уведомления СОК</b><br>Получайте уведомления о самых важных новостях прямо в браузере.';
					content.append($('<div>').css({'text-align':'left'}).html(str));

					var yesButton=$('<button>').attr('name','confirmPush').html('Подписаться').addClass('btn').addClass('btn-small').addClass('btn-blue').css({width:'80px'});
					var noButton=$('<button>').attr('name','confirmPush').html('Не сейчас').addClass('btn').addClass('btn-small').addClass('btn-red').css({marginLeft:'20px',width:'80px'});

					var buttons=$('<div>').append(yesButton).append(noButton).css({marginTop:'20px'});
					content.append(buttons);

					showMsg({
						text:content,
						time:0,
						width:'350px',
						template: 'comix-top'
					})

					noButton.click(function(){
						closeMsg()
					})
                    yesButton.click(function(){
                        yesClickCallback(yesButton);
                        closeMsg()
                    })

					setCookie('lastPushOffer',nowStr);
				},10000);
		}


        function safariSaveToken(token){
            $.ajax({
                    url:'/push-notifications/APNS/subscribe',
                    data:{token:token,topic:'all'},
                    dataType:'json'
            });
        }

        function otherBrowserSaveToken(token){
            $.ajax({
                    url:'/firebase/subscribe',
                    data:{token:token,topic:'all'},
                    dataType:'json'
            });
        }

        if ('safari' in window && 'pushNotification' in window.safari) {
            isSafari = true;
            var permissionData = window.safari.pushNotification.permission('web.ru.c-o-k.push');
            var token=permissionData.deviceToken;
            if (permissionData.permission === 'default' && lastPushOfferShowExpired) {
                showRequest = true;
            }
            else if (permissionData.permission === 'denied') {
            }
            else if (permissionData.permission === 'granted') {
                    if(token!=getCookie('pushToken')){
                        safariSaveToken(token)
                    }
            }
            if(showRequest){
                offerPushSubscribe(function(yesButton){
                        window.safari.pushNotification.requestPermission(
                            'https://www.c-o-k.ru/push-notifications/APNS', // The web service URL.
                            'web.ru.c-o-k.push',     // The Website Push ID.
                            {}, // Data that you choose to send to your server to help you identify the user.
                            function(permissionData){
                                if (permissionData.permission === 'granted') {
        							var token=permissionData.deviceToken;
                                    if(token){
        								$.ajax({
        										url:'/push-notifications/APNS/subscribe',
        										data:{token:token,topic:'all'},
        										dataType:'json'
        								});
        							}
        						}
                            }         // The callback function.
                        );
                });
            }
		}else{
            $.getScript('https://www.gstatic.com/firebasejs/7.5.2/firebase-app.js',function(){
                $.getScript('https://www.gstatic.com/firebasejs/7.5.2/firebase-messaging.js',function(){
                    var messaging;
                    var notificationPermission = Notification.permission.toLowerCase();

                    var firebaseConfig = {
                        apiKey: "AIzaSyA47iwzvYQ-5jkb0jgQ2hJ5Jg5e3GKQO8E",
                        authDomain: "cok-push-notifications.firebaseapp.com",
                        databaseURL: "https://cok-push-notifications.firebaseio.com",
                        projectId: "cok-push-notifications",
                        storageBucket: "",
                        messagingSenderId: "606728185141",
                        appId: "1:606728185141:web:2a85bc8b78ba653b"
                    };
                    // Initialize Firebase
                    firebase.initializeApp(firebaseConfig);
                    messaging = firebase.messaging();

                    messaging.onMessage(function(payload) {
                        console.log(payload.notification);
                        var notify = new Notification(payload.notification.title, payload.notification);
                        notify.onclick = function(){
                            window.location.href = payload.notification.click_action;
                        };
                    });


                    if (notificationPermission === 'default' && lastPushOfferShowExpired) {
                        showRequest = true;
                    }
                    else if (notificationPermission === 'denied') {
                    }
                    else if (notificationPermission === 'granted') {
                            messaging.getToken().then((currentToken) => {
                                console.log(1, currentToken);
                                if (currentToken!=getCookie('pushToken')) {
                                    otherBrowserSaveToken(currentToken);
                                }
                            });
                    }
                    if(showRequest){
                        offerPushSubscribe(function(yesButton){

                            Notification.requestPermission().then((permission) => {
                                if (permission === 'granted') {
                                    messaging.getToken().then((currentToken) => {
                                        if (currentToken) {
                                            otherBrowserSaveToken(currentToken);
                                        }
                                    });
                                }
                            });
                        });
                    }
                });
            });


        }


});
